import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../redux/actions/authActions";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";
import LogoutModal from "../modals/logoutModal";
import SidebarIconItem from "./sidebarIconItem";
import logoutLogo from "../../../assets/icons/sidebar/signOut.svg";

const SidebarIconComponent = ({
  userPermissionList,
  sidebarConfig,
  setOpen,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("userType");

  const [logoutShow, setLogoutShow] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  const activePath = "/" + location.pathname.split("/")[1];
  const activeSubPath = "/" + location.pathname.split("/")[2];

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const logoutSuccess = (data) => {
    setShowSuccessMsg(capitalize(data.data.message));
    setShowSuccessPopup(true);
    setTimeout(() => navigate("/"), 2000);
  };

  const logoutError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  return (
    <div className="d-none d-lg-block" style={{ height: "88vh" }}>
      <div className="d-flex flex-column justify-content-between align-items-between h-100 w-100">
        <div
          className="d-flex flex-column justify-content-center align-itmes-center py-5 text-uppercase h-100"
          onClick={() => setOpen(false)}
        >
          <ul className="nav-options w-100 h-100 d-flex flex-column justify-content-between align-items-center">
            <div className="w-100 d-flex flex-column justify-content-between align-items-center main position-relative">
              {sidebarConfig.map((item) =>
                typeof item.visible === "function"
                  ? item.visible({ userType, userPermissionList }) && (
                      <SidebarIconItem
                        key={item.label}
                        item={item}
                        activePath={activePath}
                        activeSubPath={activeSubPath}
                        navigate={navigate}
                      />
                    )
                  : null
              )}
            </div>
            <div className="w-100 nav-items-dd">
              <div
                className="logout-div d-flex justify-content-center cursor_pointer"
                title="Logout"
                onClick={() => {
                  setLogoutShow(true);
                }}
              >
                <img src={logoutLogo} width={"20px"} alt="o" />
              </div>
            </div>
          </ul>
        </div>
        <LogoutModal
          logoutShow={logoutShow}
          handleLogoutClose={() => setLogoutShow(false)}
          logoutFunc={logoutHandler}
        />
      </div>
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </div>
  );
};
export default SidebarIconComponent;
